// extracted by mini-css-extract-plugin
export var MobileMenu = "MobileMenu-module--MobileMenu--2S1Cm";
export var Head = "MobileMenu-module--Head--Aa7NE";
export var CloseBtn = "MobileMenu-module--CloseBtn--3snlO";
export var Resources = "MobileMenu-module--Resources--23i1f";
export var IntroPages = "MobileMenu-module--IntroPages--1zyeK";
export var PageLink = "MobileMenu-module--PageLink--2JkwI";
export var SelectedPage = "MobileMenu-module--SelectedPage--1zYF6";